document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;

  const closeMobileNav = () => {
    document.querySelectorAll('[data-mobile-nav]').forEach((nav) => {
      nav.classList.remove('is-active');
      nav.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-mobile-nav-toggle]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
    body.classList.remove('needventure-mobile-menu-open');
  };

  document.querySelectorAll('[data-mobile-nav-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const navId = toggle.getAttribute('aria-controls');
      const nav = navId ? document.getElementById(navId) : null;
      if (!nav) return;

      const isOpen = nav.classList.contains('is-active');
      closeMobileNav();

      if (!isOpen) {
        nav.classList.add('is-active');
        nav.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        body.classList.add('needventure-mobile-menu-open');
      }
    });
  });

  document.querySelectorAll('[data-mobile-nav-close]').forEach((button) => {
    button.addEventListener('click', closeMobileNav);
  });

  document.querySelectorAll('.mobile-nav-links a, .mobile-nav-meta a').forEach((link) => {
    link.addEventListener('click', closeMobileNav);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 989) {
      closeMobileNav();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMobileNav();
    }
  });

  document.querySelectorAll('[data-needventure-gallery]').forEach((gallery) => {
  const mainImg = gallery.querySelector('[data-gallery-main]');
  const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImg) return;

      const src = thumb.getAttribute('data-image-src');
      if (!src) return;

      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.setAttribute('src', src);
      mainImg.src = src;

      thumbs.forEach((item) => item.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
});


  document.querySelectorAll('[data-qty-controls]').forEach((wrapper) => {
    const input = wrapper.querySelector('input[name="quantity"], input.qty-input, input[type="number"]');
    wrapper.querySelectorAll('[data-qty-change]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!input) return;
        const delta = Number(button.getAttribute('data-qty-change') || 0);
        const current = Number(input.value || 1);
        input.value = Math.max(1, current + delta);
      });
    });
  });

  document.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const body = item?.querySelector('.accordion-body');
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      item?.parentElement?.querySelectorAll('.accordion-item').forEach((sibling) => {
        sibling.querySelector('[data-accordion-trigger]')?.setAttribute('aria-expanded', 'false');
        sibling.querySelector('.accordion-body')?.classList.remove('open');
      });
      if (!expanded) {
        trigger.setAttribute('aria-expanded', 'true');
        body?.classList.add('open');
      }
    });
  });

  document.querySelectorAll('[data-blog-filter-bar]').forEach((bar) => {
    const buttons = bar.querySelectorAll('[data-filter]');
    const gridId = bar.getAttribute('data-target-grid');
    const grid = gridId ? document.getElementById(gridId) : null;
    if (!grid) return;

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => item.classList.remove('active'));
        button.classList.add('active');
        const filter = button.getAttribute('data-filter');
        grid.querySelectorAll('[data-cats]').forEach((card) => {
          const cats = card.getAttribute('data-cats') || '';
          card.style.display = filter === 'all' || cats.includes(filter) ? '' : 'none';
        });
      });
    });
  });
});
